import AxiosClient from './clients/axios'

const resource = 'integrations/mobly/services/cs'

const createTicket = async (payload) => {
  const url = `${resource}/tickets`

  const response = await AxiosClient().post(url, payload)

  return response.data
}

const checkAutoPop = async (ticketId) => {
  const url = `${resource}/checkAutoPop/${ticketId}`

  const response = await AxiosClient().get(url)

  return response.data
}

export {
  createTicket,
  checkAutoPop
}
